import { Link, useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { useAuth } from "../lib/auth";
import {
  PRIVACY_POLICY_TITLE,
  PRIVACY_POLICY_INTRO,
  PRIVACY_POLICY_LAST_UPDATED,
  PRIVACY_POLICY_SECTIONS,
  PRIVACY_CONTROLLER_PLACEHOLDER,
} from "../../../shared/privacyPolicy";

export default function PrivacyPage() {
  const { user } = useAuth();
  const navigate = useNavigate();
  return (
    <div className="max-w-2xl mx-auto px-4 pt-6 pb-10 space-y-6">
      <div>
        {user ? (
          <Link
            to="/einstellungen"
            className="inline-flex items-center gap-1 text-sm text-brand-600 hover:underline"
          >
            <ChevronLeft size={16} />
            Einstellungen
          </Link>
        ) : (
          <button
            type="button"
            onClick={() => {
              // Zurück, wenn Verlauf vorhanden – sonst sicher zur Anmeldung,
              // damit der Hinweis-Link nie in einer Sackgasse endet.
              if (window.history.length > 1) navigate(-1);
              else navigate("/login");
            }}
            className="inline-flex items-center gap-1 text-sm text-brand-600 hover:underline"
          >
            <ChevronLeft size={16} />
            Zurück
          </button>
        )}
        <h1 className="mt-2 text-2xl font-bold text-[var(--color-app-text)]">
          {PRIVACY_POLICY_TITLE}
        </h1>
        <p className="mt-1 text-xs text-[var(--color-app-text-secondary)]">{PRIVACY_POLICY_LAST_UPDATED}</p>
      </div>

      <p className="text-sm text-[var(--color-app-text)] leading-relaxed">
        {PRIVACY_POLICY_INTRO}
      </p>

      <div className="space-y-5">
        {PRIVACY_POLICY_SECTIONS.map((section) => (
          <section
            key={section.id}
            id={section.id}
            className={`card p-4 ${
              section.isPlaceholder
                ? "border-2 border-[var(--color-caution)] bg-[var(--color-caution-bg)]"
                : ""
            }`}
            data-testid={`section-${section.id}`}
          >
            <h2 className="text-base font-bold text-[var(--color-app-text)]">
              {section.title}
            </h2>
            {section.paragraphs?.map((p, i) => (
              <p
                key={i}
                className="mt-2 text-sm text-[var(--color-app-text)] leading-relaxed"
              >
                {p}
              </p>
            ))}
            {section.bullets && section.bullets.length > 0 ? (
              <ul className="mt-2 list-disc pl-5 space-y-1">
                {section.bullets.map((b, i) => (
                  <li key={i} className="text-sm text-[var(--color-app-text)] leading-relaxed">
                    {b}
                  </li>
                ))}
              </ul>
            ) : null}

            {section.isPlaceholder ? (
              <div className="mt-3 rounded-lg bg-white border border-[var(--color-caution)] p-3 space-y-1.5">
                <p className="text-xs font-semibold text-[var(--color-caution)]">
                  Vom Betreiber auszufüllen:
                </p>
                {PRIVACY_CONTROLLER_PLACEHOLDER.map((row) => (
                  <div
                    key={row.label}
                    className="flex flex-col sm:flex-row sm:items-baseline sm:gap-2"
                  >
                    <span className="text-xs font-medium text-[var(--color-app-text-secondary)] sm:w-40 shrink-0">
                      {row.label}
                    </span>
                    <span className="text-sm text-[var(--color-app-text)]">{row.value}</span>
                  </div>
                ))}
              </div>
            ) : null}
          </section>
        ))}
      </div>
    </div>
  );
}
